<template>
    <div>
        <el-tag v-if="isTag" :type="tagType" size="mini" v-text="text"> </el-tag>
        <span v-else v-text="text"></span>
    </div>
</template>

<script>
export default {
    name: "StateColumn",
    props: ["data", "row"],
    data() {
        return {
            isTag: false,
            tagType: ""
        };
    },
    computed: {
        label() {
            return {
                first: {
                    text: this.$t("zhiji.knowlege.statusFirstAnswer"),
                    type: "success"
                },
                reveal: {
                    text: this.$t("zhiji.knowlege.statusNoAnswer"),
                    type: ""
                }
            };
        },
        text() {
            if (this.data && this.label[this.data]) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.isTag = true;
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.tagType = this.label[this.data].type;
                return this.label[this.data].text;
            } else {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.isTag = false;
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.tagType = "";
                return this.data;
            }
        }
    }
};
</script>
